var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 23,
    viewBox: "0 0 95 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2227 0.873535H30.2252C30.2252 0.870377 30.2283 0.86785 30.2283 0.865323C30.2252 0.86785 30.2252 0.870377 30.2227 0.873535Z",
    fill: "#0C0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1104 11.7417C16.1129 11.7392 16.1129 11.736 16.1154 11.7335H16.1129C16.1129 11.736 16.1104 11.7392 16.1104 11.7417Z",
    fill: "#0C0C0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.655 9.26866C40.655 7.96245 40.6761 6.49804 40.7094 5.6326H40.6561C40.2963 7.19472 39.5308 9.74496 38.797 12.1409H37.3869C36.8285 10.0464 36.0369 7.14087 35.701 5.61206H35.6494C35.7149 6.5097 35.7471 8.08569 35.7471 9.39856V12.1409H34.2383V4.4846H36.7019C37.2987 6.48471 37.9676 8.99443 38.198 10.1358H38.2102C38.3978 9.12932 39.2388 6.44641 39.8772 4.4846H42.2515V12.1409H40.655V9.26866Z",
    fill: "#22282B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9868 8.99165C47.3773 7.23469 47.0115 6.18606 46.8322 5.53212H46.8211C46.6329 6.25267 46.2265 7.49004 45.7369 8.99165H47.9868ZM45.4171 10.1852L44.7399 12.1409H43.3193L45.9712 4.46073H47.7714L50.5376 12.1409H49.0182L48.311 10.1852H45.4171Z",
    fill: "#22282B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0265 12.1407H57.1583C57.1039 11.9758 57.0717 11.6466 57.055 11.1493C56.702 11.7027 56.0208 12.2495 54.6869 12.2495C52.4603 12.2495 51.2656 10.5608 51.2656 8.36587C51.2656 6.05544 52.548 4.31679 54.895 4.31679C56.723 4.31679 57.8588 5.31546 58.0726 6.68218H56.9279C56.6859 5.88557 56.1063 5.25606 54.8728 5.25606C53.1214 5.25606 52.4597 6.66497 52.4597 8.31257C52.4597 9.85193 53.1381 11.3008 54.8406 11.3008C56.5115 11.3008 56.909 10.1817 56.909 8.99482V8.91599H54.8284V7.94675H58.0265V12.1407Z",
    fill: "#22282B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8781 8.10408H62.6678C63.7259 8.10408 64.2555 7.58726 64.2555 6.68851C64.2555 5.74702 63.6143 5.27628 62.7078 5.27628H60.8781V8.10408ZM59.8467 4.41473H62.78C64.2843 4.41473 65.3124 5.25407 65.3124 6.66242C65.3124 8.16792 64.2283 8.96618 62.7183 8.96618H60.8781V12.1404H59.8467V4.41473Z",
    fill: "#22282B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6593 12.1409H66.8672V4.38857H67.6593V12.1409Z",
    fill: "#22282B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3849 8.33192H70.4274V11.5683H74.7624L74.6713 12.1406H69.8057V4.37H74.5842V4.94289H70.4274V7.75959H74.3849V8.33192Z",
    fill: "#22282B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3596 19.8886C35.5339 20.658 36.0857 20.9944 36.9716 20.9944C37.8554 20.9944 38.2334 20.6452 38.2334 20.0851C38.2334 19.4617 37.8643 19.1914 36.5547 18.8866C34.4714 18.3975 33.9562 17.6398 33.9562 16.6067C33.9562 15.2722 34.9549 14.3657 36.7668 14.3657C38.7997 14.3657 39.6096 15.4587 39.7195 16.5784H38.0513C37.9714 16.1071 37.7105 15.5958 36.724 15.5958C36.0518 15.5958 35.6466 15.8734 35.6466 16.4169C35.6466 16.9492 35.9719 17.1652 37.2087 17.4516C39.4353 17.9768 39.9238 18.805 39.9238 19.8842C39.9238 21.2825 38.8657 22.2412 36.8417 22.2412C34.8982 22.2412 33.8752 21.2847 33.6914 19.8886H35.3596Z",
    fill: "#22282B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5026 18.7784H42.8105V20.8579H46.8801L46.6947 22.1331H41.3066V14.4646H46.6675V15.7403H42.8105V17.5028H46.5026V18.7784Z",
    fill: "#22282B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5207 19.8305C54.201 21.2189 53.1579 22.2375 51.2966 22.2375C48.909 22.2375 47.7549 20.5072 47.7549 18.3273C47.7549 16.2289 48.9334 14.3415 51.3621 14.3415C53.3272 14.3415 54.3153 15.485 54.5163 16.7685H53.0757C52.8765 16.0929 52.4157 15.4889 51.3132 15.4889C49.8327 15.4889 49.2476 16.8262 49.2476 18.2773C49.2476 19.6473 49.775 21.0907 51.3576 21.0907C52.4757 21.0907 52.8787 20.3807 53.0724 19.8305H54.5207Z",
    fill: "#22282B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2002 14.4365V19.049C57.2002 20.7227 58.0967 21.1918 59.0166 21.1918C60.0846 21.1918 60.8074 20.6672 60.8074 19.049V14.4365H62.1042V18.9829C62.1042 21.5371 60.6558 22.2349 58.9944 22.2349C57.3334 22.2349 55.8984 21.4916 55.8984 19.0385V14.4365H57.2002Z",
    fill: "#22282B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.12 17.8453H66.7443C67.8729 17.8453 68.3597 17.4201 68.3597 16.5957C68.3597 15.8124 67.849 15.3689 66.8454 15.3689H65.12V17.8453ZM65.12 18.7945V22.1331H63.9893V14.4202H67.0746C68.6778 14.4202 69.5338 15.2923 69.5338 16.4936C69.5338 17.5022 68.9604 18.1006 68.2554 18.3099C68.8383 18.4731 69.3912 18.9294 69.3912 20.2762V20.6165C69.3912 21.1455 69.3723 21.8028 69.4961 22.1331H68.3908C68.2515 21.7994 68.2548 21.2032 68.2548 20.461V20.3067C68.2548 19.2564 67.9628 18.7945 66.6061 18.7945H65.12Z",
    fill: "#22282B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2556 22.1331H71.1709V14.4135H72.2556V22.1331Z",
    fill: "#22282B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8435 15.2845H73.3477V14.4068H79.3741V15.2845H76.8749V22.1331H75.8435V15.2845Z",
    fill: "#22282B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4013 22.1331H80.4932V14.3941H81.4013V22.1331Z",
    fill: "#22282B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1915 18.4071H84.2823V21.4314H88.569L88.4607 22.1331H83.499V14.3808H88.3841V15.0824H84.2823V17.7059H88.1915V18.4071Z",
    fill: "#22282B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2156 20.0295C90.4432 21.0354 91.1177 21.6177 92.3551 21.6177C93.7212 21.6177 94.2486 20.9438 94.2486 20.1294C94.2486 19.2778 93.8617 18.7616 92.1924 18.3519C90.5043 17.9328 89.8132 17.3765 89.8132 16.2641C89.8132 15.2104 90.5837 14.2601 92.264 14.2601C94.0071 14.2601 94.7377 15.3093 94.8387 16.2707H94.1104C93.9427 15.4752 93.4276 14.884 92.2296 14.884C91.1538 14.884 90.5642 15.3814 90.5642 16.2147C90.5642 17.0368 91.0561 17.3582 92.4689 17.7063C94.6599 18.2486 94.9991 19.1207 94.9991 20.0683C94.9991 21.2385 94.1437 22.2239 92.3212 22.2239C90.3783 22.2239 89.6355 21.1086 89.4873 20.0295H90.2156Z",
    fill: "#22282B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8545 13.3098C18.8545 15.8321 20.9062 17.8838 23.428 17.8838C25.9498 17.8838 28.002 15.8321 28.002 13.3098C28.002 10.788 25.9498 8.73673 23.428 8.73673C20.9062 8.73673 18.8545 10.788 18.8545 13.3098ZM23.7962 9.29369C24.7284 9.54728 25.4718 11.1416 25.5333 13.0496H23.7962V9.29369ZM23.2749 9.29369V13.0496H21.5374C21.6003 11.1416 22.3432 9.54728 23.2749 9.29369ZM24.9712 9.52051C26.4373 10.0798 27.4765 11.4699 27.5789 13.0496H26.0545C26.0113 11.6042 25.6075 10.3048 24.9712 9.52051ZM22.0995 9.52051C21.4636 10.3057 21.0598 11.6042 21.017 13.0496H19.4918C19.5941 11.4699 20.6338 10.0798 22.0995 9.52051ZM26.0545 13.57H27.5789C27.4765 15.1502 26.4373 16.5398 24.9712 17.0995C25.6075 16.3153 26.0113 15.0159 26.0545 13.57ZM23.7962 13.57H25.5333C25.4718 15.478 24.7284 17.0728 23.7962 17.3259V13.57ZM21.5374 13.57H23.2749V17.3259C22.3432 17.0728 21.6003 15.478 21.5374 13.57ZM19.4918 13.57H21.017C21.0598 15.0159 21.4636 16.3144 22.0995 17.0995C20.6338 16.5398 19.5941 15.1497 19.4918 13.57Z",
    fill: "url(#paint0_linear_189_881)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1668 13.1177C12.5229 13.9794 12.0965 14.7547 11.8382 15.4484C12.6995 15.4798 13.3457 15.4056 13.5429 15.3469C13.0761 15.4892 12.3863 15.8236 11.5842 16.2645V16.2692C11.0991 18.3872 12.1374 19.5161 12.1374 19.5161C16.2098 14.7684 18.8035 11.0589 13.0625 5.48559C14.8902 8.02947 15.4162 10.1338 13.1668 13.1177Z",
    fill: "url(#paint1_linear_189_881)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58301 10.4906C5.74127 11.3781 5.97748 12.3267 6.30339 13.3373C6.71805 13.798 7.08482 14.076 7.2628 14.2193C7.47882 14.3916 7.7418 14.5348 8.02967 14.6494C7.476 13.0523 7.14446 11.6078 6.99277 10.3116C6.48466 10.3886 6.08408 10.4511 5.58301 10.4906Z",
    fill: "url(#paint2_linear_189_881)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77246 10.5334C5.15284 11.8375 5.76615 12.7396 6.30104 13.3374C5.97513 12.3268 5.73892 11.3782 5.58066 10.4906C5.3421 10.5089 5.07865 10.5235 4.77246 10.5334Z",
    fill: "url(#paint3_linear_189_881)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41352 8.23926C4.44169 8.95823 4.86622 9.57858 5.48282 9.87866C5.41238 9.37148 5.36823 8.88638 5.34945 8.42522C5.06205 8.36793 4.75352 8.30124 4.41211 8.21906L4.41352 8.23926Z",
    fill: "url(#paint4_linear_189_881)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33439 7.87598C5.33486 7.38899 5.36162 6.92831 5.41516 6.49204C4.83097 6.28729 4.45293 6.14218 4.45293 6.14218C4.39564 6.73248 4.47406 7.4862 5.33439 7.87598Z",
    fill: "url(#paint5_linear_189_881)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98399 3.76299C4.78299 4.51624 5.00935 5.28969 5.52169 5.82129C5.65835 5.10654 5.86732 4.46881 6.13124 3.90904C5.74851 3.64418 5.41744 3.40515 5.14084 3.20228C5.08448 3.39106 5.03283 3.57937 4.98399 3.76299Z",
    fill: "url(#paint6_linear_189_881)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5791 3.10285C6.88341 3.62976 7.26332 4.11439 7.74092 4.58447C8.17014 3.71429 8.73602 3.03805 9.37046 2.54965C8.96096 2.25192 8.52751 1.92789 8.08044 1.56911C7.52114 1.94292 7.00786 2.45291 6.5791 3.10285Z",
    fill: "url(#paint7_linear_189_881)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32215 0.0118153C5.94271 0.88388 5.95962 1.87945 6.38273 2.73132C6.44425 2.85812 6.51141 2.98209 6.58326 3.10278C7.01201 2.45284 7.52529 1.94285 8.0846 1.56904C7.51825 1.11305 6.92701 0.599296 6.32732 7.43866e-05L6.32215 0.0118153Z",
    fill: "url(#paint8_linear_189_881)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17879 21.3349C1.074 22.3136 0 22.1238 0 22.1238C0.934053 22.7545 5.25211 22.0046 7.02489 20.7183C6.8887 21.2734 6.47075 21.8425 5.89125 22.4141C7.29163 21.5753 9.04703 19.7382 10.0947 21.8881C10.793 21.0625 11.4824 20.2783 12.1352 19.5161C12.1352 19.5161 11.0969 18.3872 11.582 16.2692C8.66617 17.8748 5.40896 20.298 3.17879 21.3349Z",
    fill: "url(#paint9_linear_189_881)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74297 4.58289C8.53614 5.36338 9.59276 6.09315 11.0124 6.8774C9.70171 6.18379 8.55915 5.4991 7.60208 4.88673C7.37573 5.40799 7.19399 5.9889 7.07189 6.63696C8.95409 7.3672 9.82897 7.68466 9.82897 7.68466C8.96254 7.56209 7.93363 7.29066 7.0085 7.00889C6.9451 7.44891 6.90424 7.91618 6.89485 8.4149C7.58001 8.63703 7.89747 8.71874 8.55022 8.86807C7.91531 8.79575 7.39827 8.74128 6.89062 8.67788C6.89485 9.14045 6.91739 9.63025 6.97656 10.1426C7.22123 10.1651 7.48891 10.1835 7.78805 10.1971C7.48421 10.2379 7.23062 10.2788 6.99441 10.3102C7.14468 11.6073 7.47529 13.0542 8.02849 14.6499C9.33025 15.2355 10.7583 15.4215 11.838 15.4482C12.0962 14.7546 12.5227 13.9793 13.1665 13.1176C15.4159 10.1337 14.89 8.02935 13.0622 5.48548C12.6452 5.08161 12.1874 4.6693 11.6839 4.24759C11.0579 3.72115 10.2643 3.19519 9.3758 2.55136C8.74042 3.03646 8.1736 3.71223 7.74297 4.58289Z",
    fill: "url(#paint10_linear_189_881)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4453 6.00201C16.7581 7.88891 17.3297 10.1336 17.062 11.843C18.1595 10.1473 17.2799 9.3447 18.0054 8.64169C18.7352 7.93868 20.2999 8.5055 20.2999 8.5055C19.6603 6.98726 17.858 5.3286 16.1444 5.3286C15.5498 5.3286 14.9666 5.52818 14.4453 6.00201ZM16.7445 6.82289C16.5318 6.76842 16.4045 6.55099 16.4543 6.34248C16.5088 6.12928 16.722 6.00202 16.9394 6.05696C17.1484 6.10674 17.2799 6.32417 17.2254 6.53737C17.1789 6.71394 17.0164 6.83557 16.8408 6.83557C16.8089 6.83557 16.7765 6.83135 16.7445 6.82289Z",
    fill: "url(#paint11_linear_189_881)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48298 9.87883C5.68491 9.97791 5.90704 10.0427 6.14184 10.0629C6.39402 10.085 6.66592 10.1164 6.97164 10.1409C6.91529 9.62853 6.8904 9.14013 6.88946 8.67663C6.39261 8.61229 5.91126 8.53668 5.34961 8.42539C5.36839 8.88654 5.41254 9.37165 5.48298 9.87883Z",
    fill: "url(#paint12_linear_189_881)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33594 7.87585C5.40262 7.90544 5.47165 7.93408 5.54867 7.95991C6.13803 8.15903 6.5588 8.30226 6.89269 8.41309C6.90209 7.91718 6.94153 7.45133 7.00681 7.0113C6.40806 6.82956 5.85439 6.64407 5.41671 6.49191C5.36317 6.92818 5.33641 7.38887 5.33594 7.87585Z",
    fill: "url(#paint13_linear_189_881)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52246 5.82131C5.73519 6.04296 5.99583 6.22047 6.29826 6.33788C6.57298 6.44448 6.83173 6.54498 7.07217 6.63843C7.19474 5.9899 7.3746 5.40617 7.60142 4.88678C7.05057 4.53598 6.55983 4.20491 6.13201 3.90906C5.86809 4.46883 5.65912 5.10656 5.52246 5.82131Z",
    fill: "url(#paint14_linear_189_881)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_881",
    x1: 18.8545,
    y1: 13.3102,
    x2: 28.0021,
    y2: 13.3102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A07137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00595433,
    stopColor: "#A07137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_189_881",
    x1: 11.4551,
    y1: 12.5009,
    x2: 16.3939,
    y2: 12.5009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996584,
    stopColor: "#E7E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_189_881",
    x1: 8.51348,
    y1: 12.7333,
    x2: 5.22611,
    y2: 11.9033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996584,
    stopColor: "#E7E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_189_881",
    x1: 6.6173,
    y1: 12.0849,
    x2: 4.51476,
    y2: 11.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A07137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00595433,
    stopColor: "#A07137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_189_881",
    x1: 5.65116,
    y1: 9.21136,
    x2: 4.25079,
    y2: 8.8578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A07137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00595433,
    stopColor: "#A07137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_189_881",
    x1: 5.51367,
    y1: 7.16543,
    x2: 4.2735,
    y2: 6.85232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A07137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00595433,
    stopColor: "#A07137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_189_881",
    x1: 5.94009,
    y1: 4.6654,
    x2: 4.82701,
    y2: 4.38437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A07137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00595433,
    stopColor: "#A07137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_189_881",
    x1: 9.15817,
    y1: 3.39154,
    x2: 6.66547,
    y2: 2.76218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996584,
    stopColor: "#E7E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_189_881",
    x1: 7.99129,
    y1: 1.93926,
    x2: 5.92246,
    y2: 1.41692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A07137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00595433,
    stopColor: "#A07137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_189_881",
    x1: 0.0000282235,
    y1: 19.3417,
    x2: 12.1353,
    y2: 19.3417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0106737,
    stopColor: "#161B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999891,
    stopColor: "#2C313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C313B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_189_881",
    x1: 6.89043,
    y1: 8.99989,
    x2: 14.6524,
    y2: 8.99989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0106737,
    stopColor: "#161B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999891,
    stopColor: "#2C313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C313B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_189_881",
    x1: 20.0699,
    y1: 9.41639,
    x2: 13.9721,
    y2: 7.87681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0106737,
    stopColor: "#161B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999891,
    stopColor: "#2C313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C313B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_189_881",
    x1: 7.12458,
    y1: 9.5358,
    x2: 5.19243,
    y2: 9.04797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996584,
    stopColor: "#E7E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_189_881",
    x1: 7.07673,
    y1: 7.68515,
    x2: 5.23285,
    y2: 7.21961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996584,
    stopColor: "#E7E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_189_881",
    x1: 7.45007,
    y1: 5.48768,
    x2: 5.70217,
    y2: 5.04637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996584,
    stopColor: "#E7E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E9E8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logoLight.6c65c8d606bd90464c78e0bf16a8d524.svg";
export { ForwardRef as ReactComponent };